import { Route, Routes } from "react-router-dom";
import MockACTEvents from "./MockACTEvents";

export default function MockACTEventsRouter() {
  return (
    <Routes>
      <Route path="/*" element={<MockACTEvents />} />
    </Routes>
  );
}
